<template>
  <div :class="$style.base" v-test="'mock-success'">
    <div>
      <div :class="$style.heading">
        {{ $t('mock.heading') }}
      </div>
      <div>
        {{ $t('mock.info') }}
        <a
          :href="$t('mock.link_url')"
          target="_blank"
          :style="{ color: widgetSettings.color }"
          >{{ $t('mock.link_text') }}</a
        >.
      </div>
      <BaseButton :class="$style.button" @click="retry">
        {{ $t('mock.retry') }}
      </BaseButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/components/BaseButton.vue';
import { useCompanyStore } from '@/stores/company';
import widgetSettings from '@/widget-settings';

const { company } = useCompanyStore();

const retry = () => {
  window.location.replace(
    `/widget/?company=${company.id}&language=${widgetSettings.language}&mock=true`
  );
};
</script>

<style lang="scss" module>
.base {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: $spacing $spacing $spacing + 65px $spacing;
  text-align: center;
  line-height: 1.3;
}

.heading {
  font-weight: bold;
  font-size: 32px;
  margin-bottom: $spacing;
}

.button {
  margin-top: $spacing * 2;
}
</style>
